import { render, staticRenderFns } from "./ChatCard.vue?vue&type=template&id=1443c0e2&scoped=true"
import script from "./ChatCard.vue?vue&type=script&lang=js"
export * from "./ChatCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1443c0e2",
  null
  
)

export default component.exports